export const BOOKING_SELECTION_EVENT = "telefonka:booking-selection";

export function publishBookingSelection(detail = {}) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(
    new CustomEvent(BOOKING_SELECTION_EVENT, { detail })
  );
}

export function subscribeBookingSelection(handler) {
  if (typeof window === "undefined") return () => {};
  const listener = (event) => handler(event.detail || {});
  window.addEventListener(BOOKING_SELECTION_EVENT, listener);
  return () => window.removeEventListener(BOOKING_SELECTION_EVENT, listener);
}
